import { BaseInput } from "@/components/input/BaseInput";
import DashboardLayout from "@/layout/DashboardLayout.tsx";
import { Github } from "lucide-react";

export default function Integration() {
  const authGithub = () => {
    window.location.href = `https://3gtiecsm6jguvxl777ino6jdqa0vftld.lambda-url.us-east-1.on.aws/auth/github/login`;
  };
  const repositoryProviders = [
    {
      name: "GitHub",
      description:
        "Connect your GitHub repositories to get started with your projects",
      icon: Github,
      color: "bg-gray-900 hover:bg-gray-800",
      iconColor: "text-white",
    },
    // {
    //   name: "GitLab",
    //   description:
    //     "Import your GitLab projects and continue your development workflow",
    //   icon: Gitlab,
    //   color: "bg-orange-600 hover:bg-orange-700",
    //   iconColor: "text-white",
    // },
    // {
    //   name: "Bitbucket",
    //   description: "Seamlessly integrate with your Bitbucket repositories",
    //   icon: GitBranch,
    //   color: "bg-blue-600 hover:bg-blue-700",
    //   iconColor: "text-white",
    // },
  ];

  return (
    <DashboardLayout>
      <section className="app-content-dashboard">
        <div className="p-8 mx-auto mt-10">
          <div className="mb-8">
            <h1
              style={{ fontSize: 30 }}
              className="font-bold text-gray-900 mb-2"
            >
              Connect Your Code Repository
            </h1>
            <p style={{ fontSize: 18 }} className="text-gray-600 text-lg">
              Choose your preferred Git provider to import your existing
              projects or start fresh
            </p>
          </div>

          <div
            style={{ display: "flex" }}
            className=" gap-6 justify-center  flex-row"
          >
            {repositoryProviders.map((provider) => (
              <div
                key={provider.name}
                className={`border rounded-xl p-5 w-[310px]  bg-white transition-all duration-200 `}
              >
                <div
                  style={{ display: "flex" }}
                  className="text-center items-center justify-center my-2  flex-col pb-4"
                >
                  <div className="inline-flex w-16 h-16 mb-4 rounded-full bg-gray-50 items-center justify-center">
                    <provider.icon size={32} className="text-gray-700" />
                  </div>

                  <div
                    style={{ fontSize: 20 }}
                    className="text-xl font-semibold text-gray-900"
                  >
                    {provider.name}
                  </div>
                  <p
                    style={{ fontSize: 14 }}
                    className="text-gray-600 text-sm leading-relaxed"
                  >
                    {provider.description}
                  </p>
                </div>

                <BaseInput
                  type="submit"
                  className="button w-button "
                  onClick={() => authGithub()}
                  // loading={workspaceState.loading}
                  value={`Connect to ${provider.name}`}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </DashboardLayout>
  );
}
